import React, { memo } from 'react';
import { IncompleteDepositStyled } from './styled/IncompleteDepositStyled';
import BinIcon from '../../../components/icon/IconWrapped';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { ValueOf } from '../../../types';
import PaymentMethodLogo from '../../Payment/components/PaymentMethodLogo/PaymentMethodLogo';

const WIDGET_VARIANT = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
} as const;

interface IIncompleteDepositProps {
    badgeText?: string;
    buttonText?: string;
    className?: string;
    mainText?: string;
    onClick?: () => void;
    onClose?: () => void;
    paymentKey?: string;
    variant?: ValueOf<typeof WIDGET_VARIANT>;
}

function IncompleteDeposit(props: IIncompleteDepositProps) {
    const { badgeText, className, paymentKey, variant, onClose, onClick, mainText, buttonText } = props;
    const isHorizontal = variant === WIDGET_VARIANT.HORIZONTAL;
    const isVertical = variant === WIDGET_VARIANT.VERTICAL;

    return <IncompleteDepositStyled className={classNames(className, variant)}>
        <div className={'d-flex justify-content-between'}>
            <div className={'incomplete-deposit-badge f12 fw600'}>{badgeText}</div>
            <BinIcon name={'IcClose'} size={24} className={'flex-shrink-0 cursor-pointer text-secondary'} onClick={onClose}/>
        </div>
        <div className={'incomplete-deposit-content'}>
            <PaymentMethodLogo paymentKey={paymentKey} size={24}/>
            <span className={'ellipsis fw600'}>{mainText}</span>
            {isHorizontal &&
                <Button size={'sm'} variant={'secondary'}
                        onClick={onClick} className={'ms-auto'}>{buttonText}</Button>}
        </div>
        {isVertical && <Button size={'sm'} variant={'secondary'}
                               className={'w-100'} onClick={onClick}>
            {buttonText}
        </Button>}
    </IncompleteDepositStyled>;
}

export default memo(IncompleteDeposit);
